import React from 'react';
import styles from '../invoice_detail/invoiceDetailModal.module.css';

/** Reutilizado en modal detalle comprobante, OC y NEC (mismo ritmo visual). */
export function PremiumCardRow({ label, children, span2, column }) {
    return (
        <div
            className={`${styles.card} ${span2 ? styles.compactGridSpan2 : ''} ${column ? styles.cardCol : ''}`.trim()}
        >
            <div className={styles.label}>{label}</div>
            <div className={styles.value}>{children}</div>
        </div>
    );
}
